import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ProcFeeConfirmationModalUI from './ProcFeeConfirmationModalUI'

class ProcFeeConfirmationModalSF extends Component {
	constructor(props) {
		super(props)
		this.state = {
			successMsg: null,
			errorList: null,
			// form events
			submitted: false,
		}
	}

	render() {

		return (
			<ProcFeeConfirmationModalUI
				context={this.props.context}
				errorList={this.state.errorList}
				successMsg={this.state.successMsg}
				setErrorList={this.setErrorList}
				// modes
				procFeeMode={this.props.procFeeMode}
				submitted={this.state.submitted}
				// event handlers
				onSubmit={this.onSubmit}
				onProcFeeCancel={this.props.onProcFeeCancel}
				selectedPart={this.props.selectedPart}
				feeAmount={this.props.feeAmount}
				loan={this.props.loan}

			/>
		)
	}

	componentDidMount() {
		Modal.setAppElement('body')
	}

	componentDidUpdate(prevProps) {
		if (prevProps.selectedPart === this.props.selectedPart)
			return
	}

	onSubmit = (event) => {
		event.preventDefault()
		if (this.state.submitted) return

		const { context, loan, selectedPart } = this.props

		this.setState({
			successMsg: null,
			errorList: [],
			submitted: true
		})

		RestApiUtils.post(context,
			`/api/su/loans/${loan.loanId}/processingFees/payments/${selectedPart}`,
			this.onSubmitCallback
		)
	}

	onSubmitCallback = (response) => {
		let errorList = []
		if (response.errorList) {
			response.errorList.forEach(error => {
				errorList.push(error.message)
			})
		}

		this.setState({
			successMsg: response.success,
			errorList: errorList,
			submitted: false
		})

		if (response.errorList && response.errorList.length === 0) {
			setTimeout(() => {
				this.setState({
					successMsg: null
				})
				this.props.onRefreshClick()
				this.props.onProcFeeCancel()
			}, 1000)
		}
	}


	setErrorList = (errorList) => {
		this.setState({ errorList: errorList })
	}
}

export default withRouter(ProcFeeConfirmationModalSF)
